// project imports
import { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { APP_NAME, APP_VERSION } from 'config';
import useConfig from 'hooks/useConfig';
import { getTenantLogoUrl } from 'contexts/tenantAppearance';

// assets
import Logo from 'assets/images/app-logo.svg';
import DarkLogo from 'assets/images/app-logo-dark.svg';

// ==============================|| APP LOGO ||============================== //

const AppLogo = () => {
    const theme = useTheme();
    const { enterpriseLogo, enterpriseLogoDark } = useConfig();
    const tenantLogos = theme.palette.mode === 'dark' ? [enterpriseLogoDark, enterpriseLogo] : [enterpriseLogo];
    const [failedLogos, setFailedLogos] = useState([]);

    useEffect(() => {
        setFailedLogos([]);
    }, [enterpriseLogo, enterpriseLogoDark, theme.palette.mode]);

    const tenantLogo = tenantLogos.find((logo) => logo && !failedLogos.includes(logo));
    const fallbackLogo = theme.palette.mode === 'dark' ? DarkLogo : Logo;
    const logoSource = tenantLogo ? getTenantLogoUrl(tenantLogo) : fallbackLogo;

    return (
        <img
            src={logoSource}
            alt={`${APP_NAME} ${APP_VERSION}`}
            width="175"
            onError={() => tenantLogo && setFailedLogos((current) => [...current, tenantLogo])}
        />
    );
};

export default AppLogo;
